<template>
  <div class="order-status-info-content">
    <div class="order-status-bar wd-mb-4">
      <OrderStatusBoard :display-status="displayStatus" />
    </div>

    <div class="product-img wd-min-h-262px xs:wd-min-h-0">
      <v-img
        class="product-cover__image"
        :src="getImage(order.cover_image)"
        gradient="to bottom, rgba(7, 7, 7, 0.1) 0%, rgba(255, 255, 255, 0.2) 100%"
        max-height="262"
        cover
      />
      <div v-if="isCountdownShow" class="countdown-timer">
        <countdown-timer :booking-time="order.booking_time" />
      </div>

      <div v-if="breakpoints.xs" class="order-branch-info-block--mobile">
        <p class="branch-name">{{ order.branch_name }}</p>
        <div v-if="fromTngMiniProgram || isDeferPayment" class="product-name d-flex justify-center align-center">
          {{ productName }}
        </div>
        <div v-else class="product-name d-flex justify-center align-center wd-cursor-pointer" @click="goToProduct">
          {{ productName }}
          <funnow-icon class="ml-2" max-width="20" image-path="chevron-right_white.svg" />
        </div>
      </div>
    </div>

    <div class="order-branch-info">
      <div v-if="!isMovie" id="order-branch-content-block" class="content-block">
        <p class="branch-name">{{ order.branch_name }}</p>
        <div class="product-name mb-0">
          {{ productName }}
          <v-btn v-if="!fromTngMiniProgram && !isDeferPayment" min-width="32" color="orange50" variant="text" @click="goToProduct">
            <funnow-icon max-width="32" image-path="chevron-right_orange.svg" />
          </v-btn>
        </div>
      </div>

      <!-- movie product card -->
      <div v-else class="content-block d-flex">
        <div>
          <v-img class="rounded gray30" width="54" height="80" :src="movieProductCtx.image" />
        </div>
        <div class="px-3">
          <div style="font-size: 17px">{{ movieProductCtx.name }}</div>
          <div style="font-size: 13px">{{ movieProductCtx.version }}</div>
          <div class="py-2" style="font-size: 13px">{{ movieProductCtx.cinemaName }}</div>
          <div
            v-if="isCountdownShow"
            class="px-2 rounded wd-bg-orange20 wd-text-orange50"
            style="padding-top: 2px; padding-bottom: 2px; font-size: 12px; width: fit-content"
          >
            <countdown-timer :booking-time="order.booking_time" />
          </div>
        </div>
      </div>
      <!-- end: movie product card -->

      <div v-if="isDelivery" class="content-block content-block--flex">
        <div class="content-text">
          <funnow-icon class="mr-2" max-width="24" :image-path="'timer-icon.svg'" />
          <span> {{ deliveryEnjoyTime }} </span>
        </div>
      </div>
      <div v-else class="content-block">
        <div class="wd-flex wd-items-center wd-justify-between">
          <div class="wd-w-full wd-flex wd-items-center">
            <funnow-icon class="mr-2" max-width="24" :image-path="'timer-icon.svg'" />
            <div class="wd-flex-auto">
              <p v-if="isEnjoyTimeRangePrefixShow" class="enjoyTime__prefix mb-1">{{ $t('new_booking_time') }}</p>
              <client-only>
                <div class="wd-flex wd-justify-between wd-items-center">
                  <span>{{ enjoyTimeRange }}</span>
                  <div v-if="order.headcount_changeable" class="wd-min-w-[32px] wd-text-sm wd-flex wd-justify-start wd-items-center wd-gap-1">
                    <FunnowIcon activeClass="wd-w-24px" image-path="member-icon.svg" />
                    <span>
                      {{ order.occupation_count || '-' }}
                    </span>
                  </div>
                </div>
              </client-only>
            </div>
          </div>
        </div>

        <div v-if="!!originalEnjoyTime" class="wd-text-gray60 wd-ml-8">
          <!-- <p v-for="enjoyTimeRemark in enjoyTimeRemarks" :key="enjoyTimeRemark.text" :class="enjoyTimeRemark.class">
            {{ enjoyTimeRemark.text }}
          </p> -->
          <p class="enjoyTime__prefix mb-1 mt-3">
            {{ $t('origin_booking_time') }}
          </p>
          <div class="wd-flex wd-justify-between wd-items-center">
            <span>{{ originalEnjoyTime }}</span>
            <div v-if="order.headcount_changeable" class="wd-min-w-[32px] wd-text-sm wd-flex wd-justify-start wd-items-center wd-gap-1">
              <FunnowIcon activeClass="wd-w-24px" image-path="member-icon.svg" />
              <span>
                {{ order.ori_headcount || '-' }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- movie 座位資訊 -->
      <div v-if="isMovie" class="content-block content-block--flex content-block--flex--space-between">
        <div class="content-text">
          <funnow-icon class="mr-2" max-width="24" :image-path="'movie-ticket.svg'" />
          <span> {{ movieSeatsString }} </span>
        </div>
      </div>
      <!-- end: movie 座位資訊 -->

      <div v-if="isDelivery" class="content-block content-block--flex content-block--flex--space-between">
        <div class="content-text">
          <funnow-icon class="mr-2" min-width="24" :image-path="'location-stroke-icon.svg'" />
          <div>
            <p class="mb-0">{{ order.delivery?.info.address }}</p>
            <p class="mb-0 hint-text">{{ deliveryNote }}</p>
          </div>
        </div>
      </div>
      <div v-else class="content-block content-block--flex content-block--flex--space-between">
        <div class="content-text">
          <funnow-icon class="mr-2" min-width="24" :image-path="'location-stroke-icon.svg'" />
          <span> {{ branchAddress }} </span>
        </div>

        <v-btn v-if="!fromTngMiniProgram" class="text-btn" min-width="66" height="32" color="orange50" variant="text" @click="openMap">
          {{ $t('all_map') }}
        </v-btn>
      </div>
      <div v-if="isFormShown" class="content-block">
        <div class="content-block--flex content-block--flex--space-between">
          <div class="content-text">
            <funnow-icon class="wd-mr-2" min-width="24" image-path="form.svg" />
            <div>
              <div>{{ $t('attendee_form') }}</div>
              <div>{{ $t('orderdetail_form_expiry', { expiry_time: attendeeExpiryTime }) }}</div>
            </div>
          </div>
          <v-btn v-if="!fromTngMiniProgram" min-width="32" variant="text" @click="goToAttendeeForm">
            <funnow-icon max-width="32" image-path="chevron-right.svg" />
          </v-btn>
        </div>
        <div v-if="isFormHintShown" class="wd-ml-8" :class="[formHint.color]">{{ $t(formHint.text) }}</div>
      </div>
      <div v-if="showPenaltyRule" class="content-block">
        <ProductPenaltyHint :penalty-rule="productPenaltyRule" show-cancel-date />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CountdownTimer from '@/components/page/orders/countdown-timer.vue'
import FunnowIcon from '@/components/icons/funnow-icon.vue'
import OrderStatusBoard from '@/components/OrderStatusBoard.vue'
import ProductPenaltyHint from '@/components/ProductPenaltyHint.vue'
import { ProductSalesMode, type ProductPenaltyRuleResult } from '@/view-models/product'
import {
  OrderCommonStatus,
  OrderMovieStatus,
  AttendeeFormHint,
  AttendeeFormStatus,
  type OrderDetail,
  OrderDetailDisplayStatus,
} from '@/view-models/order'
import { GtmSource } from '@/view-models/gtm'
import { pushGtmSource } from '@/composition/useGtmSource'
import { useMovieOrderProduct, useOrderFlags } from '@/composition/useOrder'
import { useDeliveryCommentNote } from '@/composition/useDelivery'
import { useBookingEngine } from '@/composition/use-booking-engine'
import { useBreakpoints } from '@/composition/useBreakpoints'
import { timeUtil } from '@/utils/time'
import { ASYNC_DATA_KEYS, getAsyncDataKey } from '@/constants/async-data-keys'
import * as productService from '@/service/product'
import { usePlatformStore } from '@/store-pinia/platform'

type PropsType = {
  order: Partial<OrderDetail & { attendee_status: AttendeeFormStatus }>
  isDelivery: boolean
}

defineOptions({
  name: 'OrderStatusInfoSheet',
})
const props = withDefaults(defineProps<PropsType>(), {
  order: () => ({}),
  isDelivery: false,
})

const nuxtApp = useNuxtApp()
const { $store: store, $dayjs } = nuxtApp
const router = useRouter()
const route = useRoute()
const { t } = useI18n()
const { order } = toRefs(props)

const { isFunBookV2 } = storeToRefs(usePlatformStore())

const { movieSeatsString, productCtx: movieProductCtx } = useMovieOrderProduct(computed(() => props.order.movie || {}))
const { noteText: deliveryNote } = useDeliveryCommentNote(computed<any>(() => props.order.delivery?.info || {}))
const { isFromFunBook, isDeferPayment, isCamping, isMovie, isBookSeatOnly } = useOrderFlags(computed<any>(() => props.order))
const { data: bookingEngineData } = useBookingEngine() as any
const { breakpoints } = useBreakpoints()

const { data: productPenaltyRule } = useAsyncData(
  getAsyncDataKey(ASYNC_DATA_KEYS.PRODUCT_PENALTY, [props.order.product?.id]),
  () => {
    if (isFunBookV2.value) {
      return Promise.resolve(null)
    }
    return productService.getProductPenaltyRule(nuxtApp.$axios, props.order.product!.id, {
      bookingTime: props.order?.booking_time || null,
      currencyId: props.order?.txn_info?.currency_id || null,
      paymentCurrencyId: props.order?.currency_id || null,
    })
  },
  { immediate: false, default: () => ({} as ProductPenaltyRuleResult), watch: [() => props.order.product?.id] }
)

const { hasRule } = useProductPenaltyRule(productPenaltyRule)
const showPenaltyRule = computed(() => {
  return hasRule.value && props.order.display_status === OrderDetailDisplayStatus.BOOKED_NOT_REDEEMED_UNCOMMENTED
})

const displayStatus = computed(() => props.order.display_status as OrderDetailDisplayStatus)
const isFormShown = computed(() => {
  return (
    // 未付款、未報到
    props.order.display_status !== 21 &&
    (props.order.attendee_status === AttendeeFormStatus.Unfinished ||
      props.order.attendee_status === AttendeeFormStatus.Finished ||
      (props.order.attendee_status === AttendeeFormStatus.None && props.order.attendee_expiry_time))
  )
})
const isFormHintShown = computed(() => props.order.attendee_status !== AttendeeFormStatus.None)
const formHint = computed(() => AttendeeFormHint[props.order.attendee_status!])

const attendeeExpiryTime = computed(() => timeUtil.formatDateTime(props.order.attendee_expiry_time))

function goToAttendeeForm() {
  const url = props.order.form_link
  window.open(url, '_blank')
}

const fromTngMiniProgram = computed(() => store.getters.fromTngMiniProgram)
const isBookingEngine = computed(() => store.getters.isBookingEngine)

const isOvertime = computed(() => {
  return $dayjs(props.order.booking_time).unix() <= $dayjs().unix()
})

const isBooking = computed(() => {
  return props.order.order_status === 'booking-success' || isRedeem.value || isCommented.value
})

const isRedeem = computed(() => {
  return hasCert.value || isCommented.value || props.order.order_status === 'redeem' || props.order.movie?.status === OrderMovieStatus.Redeem
})

const isCommented = computed(() => {
  return props.order.order_status === 'commented' || props.order.movie?.status === OrderMovieStatus.Commented
})

const isCancel = computed(() => {
  return props.order.order_status === 'cancel' || props.order.movie?.status === OrderMovieStatus.Cancel
})

const isCert = computed(() => {
  return props.order.sales_mode === ProductSalesMode.Voucher
})

const hasCert = computed(() => {
  if (props.order.hasOwnProperty('cert')) {
    return !!props.order.cert?.cert_path
  }
  return false
})

const isEnjoyTimeRangePrefixShow = computed(() => {
  if (props.order.order_status !== 'booking-success') {
    return false
  }
  return !!props.order.original_time && !isMovie.value
})

const enjoyTimeRange = computed(() => {
  const startTime = timeUtil.formatDateTime(props.order.booking_time)
  const endTime = timeUtil.formatEndTimeValue(props.order.end_time_text)
  return t('booking_time_period_format', { starttime: startTime, endtine: endTime })
})

const originalEnjoyTime = computed(() => {
  if (props.order.order_status !== OrderCommonStatus.BookingSuccess || isMovie.value) {
    return null
  }

  if (props.order.original_time) {
    const startTime = $dayjs(props.order.original_time).format('YYYY/MM/DD HH:mm')
    const $endTime = $dayjs(props.order.original_end_time_text)
    const isDateTime = $endTime.isValid()
    const endTime = isDateTime ? $endTime.format('YYYY/MM/DD HH:mm') : props.order.original_end_time_text

    return t('booking_time_period_format', { starttime: startTime, endtine: endTime })
  }

  return null
})

const productName = computed(() => {
  return props.order.hasOwnProperty('product') ? props.order.product?.name : ''
})

const { fullAddress, googleMapDirLink } = useAddress(order)

const branchAddress = computed(() => `${order.value.zip} ${fullAddress.value}`)

const productID = computed(() => props.order.product?.id)

const deliveryEnjoyTime = computed(() => {
  if (props.isDelivery) {
    const deliveryTime = props.order.delivery?.estimated_delivery_time
    const $dateTime = $dayjs(deliveryTime)
    return $dateTime.isValid() ? $dateTime.format('YYYY/MM/DD HH:mm') : deliveryTime
  }
  return ''
})

const isCountdownShow = computed(
  () => isBooking.value && !isRedeem.value && !isCert.value && !isOvertime.value && !props.isDelivery && !isCamping.value
)

function getImage(imgPath: string = '') {
  return `${useRuntimeConfig().public.CDN_URI}${imgPath}`
}

function goToProduct() {
  pushGtmSource(GtmSource.ORDER_DETAIL)
  if (isBookingEngine.value && props.order.domain_prefix) {
    router.push({
      path: nuxtApp.$localePath(`/branches/${bookingEngineData.value.branchId}/funbook`),
      query: { ...route.query, subdomain: props.order.domain_prefix },
    })
    return
  }

  if (isFromFunBook.value) {
    router.push(nuxtApp.$localePath(`/funbook/${props.order.branch_id}/products/${productID.value}`))
    return
  }

  router.push(nuxtApp.$localePath(`/products/${productID.value}`))
}

function openMap() {
  window.open(googleMapDirLink.value, '_blank')
}
</script>

<style lang="scss" scoped>
.order-status-info-content {
  padding: 0 20px;

  @include xxs {
    padding: 0;
  }

  .order-status-bar {
    .status-group {
      display: flex;
      justify-content: space-around;
      .order-status-box {
        text-align: center;
        width: 30%;
        padding: 8px 0;
        color: $gray80;

        &.cancel {
          color: $orange50;

          .status-icon {
            background-color: $orange30;
          }
        }

        &.actived {
          color: $orange50;

          .status-icon {
            background-color: $orange50;
          }
        }

        .status-icon {
          margin: 0 auto 12px;
          width: 32px;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 32px;
          background-color: $gray40;
        }

        .status-text {
          font-size: 13px;
        }
      }
    }
  }

  .product-img {
    position: relative;
    border-radius: 4px;
    overflow: hidden;

    .order-branch-info-block--mobile {
      display: none;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;

      .branch-name {
        font-size: 17px;
        font-weight: 500;
      }

      @include xxs {
        display: block;
        color: white;
      }
    }

    .countdown-timer {
      height: 24px;
      padding: 0 8px;
      border-radius: 4px;
      font-size: 13px;
      line-height: 24px;
      position: absolute;
      bottom: 16px;
      right: 16px;
      background-color: white;

      @include xxs {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }

    @include xxs {
      border-radius: 0;
      background-image: linear-gradient(to bottom, rgba(7, 7, 7, 0.2) 0%, rgba(0, 0, 0, 0.8) 100%);
    }
  }

  .order-branch-info {
    #order-branch-content-block {
      @include xxs {
        display: none;
      }
    }

    .content-block {
      padding: 20px 0;
      border-bottom: 1px solid $gray40;
      &:last-child {
        @apply xs:wd-pt-5 sm:wd-pb-0;
        border-bottom: none;
      }

      &--flex {
        display: flex;
        align-items: center;
        &--space-between {
          justify-content: space-between;
        }
      }

      .content-text {
        display: flex;
        align-items: center;

        .hint-text {
          font-size: 13px;
          line-height: 20px;
          color: $gray80;
        }
      }

      :deep(.enjoyTime__prefix) {
        font-size: 13px;
        line-height: 20px;
      }

      .go-to-btn {
        cursor: pointer;
      }

      .text-btn {
        font-size: 15px;
      }

      .branch-name {
        margin-bottom: 20px;
        font-size: 17px;
      }

      .product-name {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 24px;
        font-weight: 500;
        color: $orange50;
      }
    }
  }
}
</style>
